import PropTypes from "prop-types";
import {
  LineChart,
  Line,
  XAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { formatNumber, scaleNumber } from "../../utils/utils";

const CustomTooltip = ({ active, payload, label, unit }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white border border-gray-300 p-2 rounded text-sm text-black">
        <p>{`Jahr: ${label}`}</p>
        <p>{`Installierte Leistung: ${formatNumber(scaleNumber(payload[0].value, 1000), 1, 1)} ${unit}`}</p>
      </div>
    );
  }
  return null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  unit: PropTypes.string.isRequired,
};

const LineChartComponent = ({ data, color, title, unit }) => {
  const currentYear = new Date().getFullYear();
  const yearsBack = 10;
  const filteredData = data.filter(
    (entry) => parseInt(entry.year) >= currentYear - yearsBack
  );

  return (
    <div className="w-full max-w-sm mx-auto">
      <h4 className="text-sm font-semibold text-center mb-5 py-5">{title}</h4>
      <div className="aspect-[5/4]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={filteredData}
            margin={{ top: 5, right: 10, left: 0, bottom: 5 }}
          >
            <XAxis
              dataKey="year"
              tick={{ fontSize: 10, fill: "#000" }}
              interval="preserveStartEnd"
            />
            {/* unit korrekt übergeben */}
            <Tooltip content={(props) => <CustomTooltip {...props} unit={unit} />} />
            <Line
              type="monotone"
              dataKey="value"
              stroke={color[1]}
              strokeWidth={3}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

LineChartComponent.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      year: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ).isRequired,
  color: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string,
  unit: PropTypes.string.isRequired,
};

export default LineChartComponent;
